import { forwardRef } from 'react';
import * as Styled from './Switch.styled';
import { SwitchProps } from './Switch.typed';

const Switch = forwardRef<HTMLInputElement, SwitchProps>((props, ref) => {
  const { size = 'l', ...rest } = props;
  return (
    <Styled.Container size={size}>
      <Styled.Input ref={ref} {...rest} type="checkbox" role="switch" />
      <Styled.Track />
      <Styled.Disc size={size} />
    </Styled.Container>
  );
});

export default Switch;
